// extracted by mini-css-extract-plugin
export default {"navigation":"styles_navigation__uAVz4","search_title":"styles_search_title__Yqigj","search_tags":"styles_search_tags__gLlqr","reset_btn":"styles_reset_btn__vHnrM"};